import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

const FALLBACK = {
  catalogueUrlWithPrices: 'https://heyzine.com/flip-book/d8789c509d.html',
  catalogueUrlWithoutPrices: 'https://heyzine.com/flip-book/b1a599dc29.html',
};

let cachedSettings = null;
let cachePromise = null;

export function useSiteSettings() {
  const [settings, setSettings] = useState(cachedSettings || FALLBACK);

  useEffect(() => {
    if (cachedSettings) return;
    if (!cachePromise) {
      cachePromise = fetch(`${API}/api/site-settings`)
        .then((r) => (r.ok ? r.json() : FALLBACK))
        .catch(() => FALLBACK);
    }
    cachePromise.then((data) => {
      cachedSettings = data;
      setSettings(data);
    });
  }, []);

  return settings;
}
